import { FormControl, MenuItem, Pagination, Select, Stack, Typography } from "@mui/material";
import {
	GridFooterContainer,
	gridPageCountSelector,
	gridPageSelector,
	gridPageSizeSelector,
	gridRowCountSelector,
	useGridApiContext,
	useGridSelector,
} from "@mui/x-data-grid";
import { ThemeColors } from "../../../../../theme/themeValues";

export function CustomDataGridFooter() {
	const apiRef = useGridApiContext();

	const page = useGridSelector(apiRef, gridPageSelector);
	const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
	const pageCount = useGridSelector(apiRef, gridPageCountSelector);
	const rowCount = useGridSelector(apiRef, gridRowCountSelector);

	const pageSizes = [10, 25, 50];

	return (
		<GridFooterContainer>
			<Stack
				direction="row"
				justifyContent="flex-end"
				alignItems="center"
				p={2}
				spacing={2}
				sx={{
					borderTop: "1px solid rgba(0,0,0,0.1)",
					bgcolor: "background.paper",
					width: "100%",
				}}
			>
				<FormControl size="small" sx={{ flexDirection: "row", gap: 1, alignItems: "center" }}>
					<Typography variant="inherit" color="primary">
						Rows per page:
					</Typography>
					<Select
						variant="standard"
						disableUnderline
						value={pageSize}
						onChange={(e) => apiRef.current.setPageSize(Number(e.target.value))}
						sx={{
							color: ThemeColors.LightPrimary,

							"& .MuiSelect-select": {
								display: "flex",
								alignItems: "center",
								paddingY: 0,
								minHeight: "unset",
								fontSize: ".875em",
							},
						}}
					>
						{pageSizes.map((size) => (
							<MenuItem key={size} value={size}>
								<Typography variant="inherit" color="primary" fontWeight={"700"}>
									{size}
								</Typography>
							</MenuItem>
						))}
					</Select>
				</FormControl>

				<Typography variant="inherit" color="primary">
					Page <strong>{page + 1}</strong> of <strong>{pageCount}</strong> — Total <strong>{rowCount}</strong>{" "}
					items
				</Typography>

				<Pagination
					count={pageCount}
					page={page + 1}
					onChange={(_, value) => apiRef.current.setPage(value - 1)}
					color="primary"
					shape="rounded"
				/>
			</Stack>
		</GridFooterContainer>
	);
}
